import React, { useEffect } from "react";

const PageWrapper = ({ children }) => {
	
	// console.log("Size", document.documentElement.scrollHeight, document.body.scrollHeight, window.innerHeight);
	
	return children;
};

export default PageWrapper;